import React, { Suspense } from "react";
import { withTranslation } from "react-multi-lang";
import { withAlert } from "react-alert";
import IdleTimer from "react-idle-timer";
import { withRouter } from 'react-router-dom';
import $ from "jquery";
import store from "./../../redux_store/store/index";
import Service from "./Service.jsx";
import {
  Silentauditobject,
  // Silentauditobjectonlogout,
  Serviceforuserrights,
  Serviceforauditconfig,
  Servicecalls,
  // LogoutSessionClear,
} from "./../../custom_functions/Functions.jsx";
import { updateInactiveLogout } from "./../../redux_store/actions/index";
import { isMultitenant } from "../../custom_functions/Constance";

const Idlepop = React.lazy(() => import("./Idlepop.jsx"));

class ApplicationFooter extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      modalopen: false,
      UserName: store.getState().Loggeduser !== undefined &&
        store.getState().Loggeduser !== null &&
        Object.keys(store.getState().Loggeduser).length > 0 ?
        store.getState().Loggeduser.username :
        $.session.get("Username") !== undefined &&
          $.session.get("Username") !== ""
          ? $.session.get("Username")
          : "",
      time: (sessionStorage.idletime === undefined || sessionStorage.idletime === 'undefined') ?
        15 : JSON.parse(sessionStorage.idletime),
      // idle_save:false
    };
    this.idleTimer = null;
    this.timerID = null;
    this.ELNurl = window.appUrl.ELN;


  }

  componentDidMount() {
    this._isMounted = true;
  }


  componentWillUnmount() {
    this._isMounted = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.idletime !== undefined && nextProps.idletime !== "undefined" && nextProps.idletime !== "") {
      this.setState({
        time: JSON.parse(nextProps.idletime)
      })
    }
  }

  setupBeforeUnloadListener = () => {
    window.addEventListener("beforeunload", (ev) => {
      let passObjDet = {
        usercode: sessionStorage.getItem("User"),
        activeusercode: sessionStorage.getItem('activeUserId')
      };
      passObjDet.objsilentaudit = Silentauditobject(
        "Logout",
        "logout",
        this.props.t("compareObjs.IDS_LOGOUTUSER", {
          user: sessionStorage.getItem("Username"),
        })
      );
      store.dispatch(updateInactiveLogout(true));
      this.setState({
        ServiceToUrl: "" + this.ELNurl + "/Login/Logout",
        ServiceHeaderobject: passObjDet,
        ServiceMethodType: "POST",
        ServcieonSuccess: this.props.onlogoutSuccess,
        ServcieonFailure: this.props.onlogoutFailure,
      });
    });
  };

  handleautosave() {
    if (this.props?.idle_save !== undefined && this.props?.idle_save) {
      this.props.idle_save();
    }
  }

  onlogoutonIdleTime(user) {

    if (this.ELNurl.trim() !== "") {

      const getOrderDetail = store.getState().Sheetview;

      const storedataforprotocolorder = store.getState().OpenprotocolordersDatas;
      const { OrderTestcode } = getOrderDetail || {};
      const { protocolOrder, protocolorderopen } = storedataforprotocolorder || {};
      const lockeduser = protocolOrder?.lockeduser || undefined;
      if ((OrderTestcode?.batchcode || (protocolOrder?.protocolordercode && lockeduser === Number(sessionStorage.User)))) {
        let passObjDet1 = { usercode: sessionStorage.getItem("User") };
        if (getOrderDetail?.OrderTestcode?.batchcode !== undefined && getOrderDetail.OrderTestcode.batchcode !== null) {
          passObjDet1.Batch = getOrderDetail.OrderTestcode.batchcode
        }
        if (protocolorderopen && protocolOrder?.protocolordercode && lockeduser === Number(sessionStorage.User)) {
          passObjDet1.protocolordercode = storedataforprotocolorder.protocolOrder?.protocolordercode;
        }
        const url = this.ELNurl + "/File/unlockorderOnViewClose";
        fetch(url, {
          method: "POST", body: JSON.stringify(passObjDet1),
          headers: new Headers({
            Authorization: sessionStorage.getItem("Token"),
            "X-TenantID": sessionStorage.getItem("tenantid"),
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        })
          .then(response => { }).catch(error => { });
        // }
      }

      let passObjDet = user;
      passObjDet.activeusercode = sessionStorage.getItem('activeUserId');
      passObjDet.objsilentaudit = Silentauditobject(
        "Logout",
        "logout",
        this.props.t("compareObjs.IDS_LOGOUTUSER", {
          user: this.state.UserName,
        })
      );

      this.setState({
        modalopen: false,
      });

      store.dispatch(updateInactiveLogout(true));

      if (sessionStorage.ActiveNewTab === "1") {
        Servicecalls("" + this.ELNurl + "/Login/Logout",
          passObjDet,
          () => {
            let tenantdomain = $.session.get("tenantdomain");
            sessionStorage.removeItem("ActiveNewTab");
            if (tenantdomain !== undefined) {
              isMultitenant === 0
                ? this.props.history.push("/")
                : this.props.history.push("/#" + tenantdomain);
              this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
            } else {
              this.props.history.push("/")
            }
            // LogoutSessionClear();
          }, () => { });
      } else {
        this.setState({
          ServiceToUrl: "" + this.ELNurl + "/Login/Logout",
          ServiceHeaderobject: passObjDet,
          ServiceMethodType: "POST",
          ServcieonSuccess: this.props.onlogoutSuccess,
          ServcieonFailure: this.props.onlogoutFailure,
        });
      }

    }
  }

  onLoginClick(user, password) {
    let objdat = {};
    let username = this.state.UserName === "" ? user.username : this.state.UserName
    objdat["sUsername"] = username;
    objdat["sPassword"] = password;
    objdat["sDomainName"] = this.state.DomainCode;
    objdat["sCategories"] = this.state.DomainCategory;
    objdat["sSiteCode"] = user.lssitemaster.sitecode;
    objdat["logindate"] = new Date();
    objdat["idlelogin"] = true;
    objdat["objsilentaudit"] = Silentauditobject(
      "login",
      "Login",
      this.props.t("compareObjs.IDS_LOGGEDIN", { user: username })
    );
    objdat["multiusergroupcode"] = $.session.get("multiusergroups");
    let url = "";
    if (
      $.session.get("loggedfrom") !== undefined &&
      $.session.get("loggedfrom") === "1"
    ) {
      url = "" + this.ELNurl + "/Login/azureauthenticatelogin";
    } else if (isMultitenant === 2) {
      objdat = {};
      objdat = { usercode: sessionStorage.getItem("User"), password: password };
      url = "" + this.ELNurl + "/Freeuserlogin/Loginfreeuserwithname";
    } else if (sessionStorage.isadsuser === "1") {
      url = "" + this.ELNurl + "/Login/adsUserValidation";
    } else {
      url = "" + this.ELNurl + "/Login/Login";
    }
    objdat.lsusergroup = { usergroupcode: sessionStorage.multiusergroups, usergroupname: sessionStorage.usergroupname }
    Servicecalls(
      url,
      objdat,
      this.onLoginSuccess.bind(this),
      this.onLoginFailure.bind(this)
    );


  }

  onLoginSuccess(response) {
    if (isMultitenant === 2 && response.user.autenticatefrom === 0)
      response.user.objResponse = response.objResponse;
    if (isMultitenant === 2 && response?.user?.objResponse?.status) {
      this.setState({
        modalopen: false,
      });
    } else if (response?.user?.objResponse?.information === "Invalid password") {
      this.props.alert.error("Invalid password");
      // this.setState({password:""})
    } else if (response?.user?.objResponse?.information === "IDS_WRONGCREDENTIAL") {
      this.props.alert.error(this.props.t("ADS password invalid"));
    } else {
      if (isMultitenant === 2 && response.user.autenticatefrom === 0) {
        let token = "Bearer " + response.token;
        sessionStorage.removeItem("Token");
        sessionStorage.setItem("Token", token);
        response.user.objResponse = response.objResponse;
      }
      let loggeduser = response.user;
      if (loggeduser.objResponse.status) {
        $.session.set("User", loggeduser.usercode);
        $.session.set("Username", loggeduser.username);
        $.session.set("Usersite", loggeduser.lssitemaster.sitecode);
        $.session.set("Usersitename", loggeduser.lssitemaster.sitename);
        $.session.set("usergroupname", loggeduser.lsusergroup?.usergroupname);
        store.getState().Loggeduser = loggeduser;
        // store.dispatch(updatecontrolrights(response.userrights));
        // store.dispatch(addauditoption(response.auditconfig));
        this.setState({
          modalopen: false,
        });

        if (isMultitenant !== 2) {
          Serviceforuserrights(
            "" + this.ELNurl +
            "/User/GetUserRightsonUser",
            {
              usercode: loggeduser.usercode,
              lsusergroup: {
                usergroupcode: response.multiusergroupcode,
                usergroupname: loggeduser.lsusergroup?.usergroupname,
              },
            }
          );
          Serviceforauditconfig(
            "" + this.ELNurl +
            "/AuditTrail/GetAuditconfigUser",
            {
              usercode: loggeduser.usercode,
              lssitemaster: { sitecode: Number(sessionStorage.Usersite), sitename: sessionStorage.Usersitename },
              lsusergroup: { usergroupcode: response.multiusergroupcode },
            }
          );
        }
      } else if (response.user.objResponse.information === "ID_NOTACTIVE") {
        this.props.alert.error(
          this.props.t("Login.IDS_MSG_NOTACTIVE", { param: "" })
        );
      } else if (response.user.objResponse.information === "ID_GRPNOACT") {
        this.props.alert.error(
          this.props.t("Login.IDS_MSG_GRPNOACT", { param: "" })
        );
      } else if (response.user.objResponse.information === "ID_INVALID") {
        this.props.alert.error(
          this.props.t("Header.IDS_MSG_INVALID", { param: "" })
        );
      } else if (response.user.objResponse.information === "IDS_MSG_NOTEXIST") {
        this.props.alert.error(
          this.props.t("Login.IDS_MSG_NOTEXIST", { param: "" })
        );
      } else if (response.user.objResponse.information === "IDS_MSG_LOCKED") {
        this.props.alert.error(this.props.t("Login.IDS_MSG_LOCKED", { param: "" }));
      } else if (response.user.objResponse.information === "ID_EXPIRY") {
        this.props.alert.error(
          this.props.t("Login.IDS_MSG_EXPIRY", { param: "" })
        );
        let site = response.user.lssitemaster.sitecode;
        this.props.onforgot(site, this.state.UserName);
      }
    }
  }
  onLoginFailure(response) { }

  handleOnAction(event) { }

  handleOnActive(event) { }

  handleOnIdle(event) {
    this.closeAllModals()
    this.setState({ modalopen: true });

  }


  closeAllModals = () => {
    document.querySelectorAll('.modal[style*="display: block"], .react-confirm-alert, .react-confirm-alert-overlay, .modal-backdrop').forEach(element => {
      element.remove();  // Remove all specified elements
    });
  };

  render() {
    return (
      <div>
        <Service
          Tourl={this.state.ServiceToUrl}
          MethodType={this.state.ServiceMethodType}
          onSuccess={this.state.ServcieonSuccess}
          onFailure={this.state.ServcieonFailure}
          Headerobject={this.state.ServiceHeaderobject}
          onReseturl={() => {
            this.setState({ ServiceToUrl: "" });
          }}
        ></Service>
        {this.state.time !== -1 ?
          <div>
            <Suspense fallback={<div></div>}>
              <Idlepop
                Isopen={this.state.modalopen}
                onLogout={this.onlogoutonIdleTime.bind(this)}
                onLogin={this.onLoginClick.bind(this)}
                handleautosave={this.handleautosave.bind(this)}
              />
            </Suspense>
            <IdleTimer
              ref={(ref) => { this.idleTimer = ref; }}
              // timeout={5000}
              timeout={1000 * 60 * this.state.time}
              onActive={this.handleOnActive.bind(this)}
              onIdle={this.handleOnIdle.bind(this)}
              onAction={this.handleOnAction.bind(this)}
              debounce={250}
              element={document.body}
            />
          </div>
          : false}
      </div>
    );
  }
}
export default withAlert()(withRouter(withTranslation(ApplicationFooter)));
